import { c as _c } from "react/compiler-runtime";
import { useUser } from '@auth0/nextjs-auth0';
import { isSingleOptInEnabled } from '~/utils/singleOptInFlag';
export type EmailCaptureGate = {
  showEmailCapture: boolean;
  topRightCtaOpensCapture: boolean;
  flagEnabled: boolean;
  isLoggedIn: boolean;
};
export function useEmailCaptureGate() {
  const $ = _c(4);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = isSingleOptInEnabled();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const flagEnabled = t0;
  const isLoggedIn = Boolean(user);
  const showEmailCapture = flagEnabled;
  const t1 = showEmailCapture && !isLoggedIn;
  let t2;
  if ($[1] !== isLoggedIn || $[2] !== t1) {
    t2 = {
      showEmailCapture,
      topRightCtaOpensCapture: t1,
      flagEnabled,
      isLoggedIn
    };
    $[1] = isLoggedIn;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}